import { createContext, useContext } from 'react';
import { useGetTokenSelector, UseTokenSelectorReturn } from '../../hooks';
import { ModeLeagueType } from '../../leagues';

export const TokensContext = createContext<UseTokenSelectorReturn | undefined>(
  undefined,
);

export const useTokensContext = () => {
  const context = useContext(TokensContext);

  if (!context) {
    throw new Error('useTokensContext must be used within TokensProvider');
  }

  return context;
};

export const TokensProvider = ({
  children,
  mode,
}: {
  children: any;
  mode: ModeLeagueType;
}) => {
  const tokens = useGetTokenSelector(mode);

  return (
    <TokensContext.Provider value={{ ...tokens }}>
      {children}
    </TokensContext.Provider>
  );
};
